var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'progress-container': true, 'active': _vm.active}},[_c('span',{staticClass:"progress-bar",style:({ width: _vm.progress + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }